document.addEventListener('DOMContentLoaded', function() {

  /***
  DESKTOP FILTER
  ***/
  const detailsElements = document.querySelectorAll('.filters-container details');
  detailsElements.forEach(details => {
    details.addEventListener('toggle', event => {
      if (details.open) {
        detailsElements.forEach(otherDetails => {
          if (otherDetails !== details) {
            otherDetails.open = false;
          }
        });
      }
    });
  });

  /***
  PRODUCT / MODEL
  ***/
  const grid = document.querySelector('[data-product-grid]');
  const buttons = document.querySelectorAll('.button-view-product');
  const mobileToggleButtons = document.querySelectorAll('.button-view-toggle-mobile');

  if (!grid || !buttons.length) return;

  function setMode(mode) {
    const items = grid.querySelectorAll('.product-small, .product-large');

    items.forEach(item => {
      const primary = item.querySelector('.product-img-primary');
      const secondary = item.querySelector('.product-img-secondary');

      if (!primary || !secondary) return;

      if (mode === 'model') {
        primary.classList.add('opacity-0', 'group-hover:opacity-100');
        primary.classList.remove('group-hover:opacity-0');
        secondary.classList.remove('opacity-0', 'group-hover:opacity-100');
        secondary.classList.add('opacity-100', 'group-hover:opacity-0');
      } else {
        primary.classList.remove('opacity-0');
        primary.classList.add('group-hover:opacity-0');
        secondary.classList.add('opacity-0', 'group-hover:opacity-100');
        secondary.classList.remove('opacity-100', 'group-hover:opacity-0');
      }
    });
    grid.dataset.view = mode;
    buttons.forEach(b => b.classList.remove('active'));
    const active = [...buttons].find(b => b.value === mode);
    if (active) {
      active.classList.add('active');
    }
    /***
    MOBILE TOGGLE LABEL UPDATE
    ***/
    mobileToggleButtons.forEach(mobileBtn => {
      const nextMode = mode === 'product'
          ? 'model'
          : 'product';
      mobileBtn.dataset.currentView = mode;
      const targetButton = [...buttons].find(
          b => b.value === nextMode
      );
      if (targetButton) {
        mobileBtn.textContent = targetButton.textContent.trim();
      }
    });
  }

  /***
  DESKTOP BUTTONS
  ***/
  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      setMode(btn.value);
    });
  });

  /***
  MOBILE TOGGLE BUTTON
  ***/
  mobileToggleButtons.forEach(mobileBtn => {
    mobileBtn.addEventListener('click', () => {
      const currentView = grid.dataset.view || 'product';
      const nextView = currentView === 'product'
          ? 'model'
          : 'product';
      setMode(nextView);
    });
  });

  setMode('product');

  /***
  FILTER ACCORDION UI (ARROW + ACTIVE COUNT)
  ***/
  function updateAccordionUI() {
    document.querySelectorAll('.accordion-block').forEach(details => {

      const checkboxes = details.querySelectorAll('input[type="checkbox"]');
      const activeCount = [...checkboxes].filter(cb => cb.checked).length;

      const counter = details.querySelector('.js-filter-count');
      const containerCounter = details.querySelector('.container-filter-count');

      if (counter) {
        counter.textContent = activeCount;

        if (activeCount > 0) {
          counter.style.display = 'inline-block';
          containerCounter.classList.remove("hidden");
        } else {
          counter.style.display = 'none';
          containerCounter.classList.add("hidden");
        }
      }
    });
  }

  /***
  GLOBAL LISTENER (checkbox changes)
  ***/
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[type="checkbox"]')) {
      updateAccordionUI();
    }
  });

  /***
  INIT
  ***/
  window.updateAccordionUI = updateAccordionUI;
  updateAccordionUI();

});